<template>
    <div class="counselling-list">
        <div v-for="(counsellingPost, index) in counsellingPosts" :key="index" class="counselling-list__post" data-cy="counselling-post">
            <div>
                <nuxt-link :to="counsellingPost.url || '/'">
                    <div class="counselling-list__date">
                        {{ $t('counselling.questionFromDate', { date: counsellingPost.createdAt }) }}
                    </div>
                    <div class="counselling-list__title-container">
                        <h2 class="counselling-list__title">{{ counsellingPost.title }}</h2>
                        <span v-for="(tag, tagIndex) in counsellingPost.tags" :key="tagIndex" class="counselling-list__tag">{{
                            tag.title
                        }}</span>
                    </div>
                    <p class="counselling-list__text" v-html="counsellingPost.question"></p>
                </nuxt-link>
                <nuxt-link class="counselling-list__show-answer" :to="counsellingPost.url">{{ $t('counselling.showAnswer') }}</nuxt-link>
            </div>
            <div class="counselling-list__author">
                <nuxt-link :to="counsellingPost.author.url">
                    <ElementsCounsellingResponder :responder="counsellingPost.author" />
                </nuxt-link>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { PropType } from 'vue'
import CounsellingQuestion from '~/models/Counselling/CounsellingQuestion'

const props = defineProps({
    counsellingPosts: {
        type: Array as PropType<CounsellingQuestion[]>,
        required: true,
    },
})
const { counsellingPosts } = toRefs(props)
</script>

<style lang="scss" scoped>
.counselling-list {
    &__date {
        font-size: 12px;
        color: $color-dark;
        margin-bottom: 13px;
    }

    &__title {
        font-weight: 590;
        font-size: 16px;
        margin: 0 10px 0 0;
        display: inline-block;
    }

    &__post {
        border-radius: 10px;
        display: grid;
        box-shadow: 0px 0px 11px 0px rgba(0, 0, 0, 0.12);
        margin-bottom: 13px;
        padding: 26px 29px;
        grid-gap: 30px;

        @include screen-lg {
            grid-template-columns: 65% 35%;
        }
    }

    &__text {
        font-size: 14px;
        line-height: 20px;
        color: $color-dark;
    }

    &__author {
        align-self: center;
    }

    &__tag {
        background: $color-peach;
        border-radius: 100px;
        color: $color-dark;
        padding: 4px 10px;
        font-size: 12px;
        font-weight: 590;
        white-space: nowrap;
        line-height: normal;
    }

    &__title-container {
        line-height: 30px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        flex-wrap: wrap;
        gap: 10px;
    }

    &__show-answer {
        color: $color-cta;
        text-decoration: underline;
        cursor: pointer;
        font-size: 14px;

        &:hover {
            color: darken($color-cta, 10%);
            text-decoration: none;
        }
    }
}
</style>
